export default "__VITE_ASSET__CMVcMzFo__"